module.exports = __webpack_public_path__ + "static/media/profileIcon.4ed0959a.svg";